import React from 'react';
import { Stack, Typography, Checkbox, Button } from '@mui/material';

const CourseUnits = ({
  courseName,
  courseUnits,
  excludedUnitIds,
  onToggleSelection
}) => {
  const courseUnitIds = courseUnits.map(({ unit }) => unit.id);

  const allUnitsSelected = courseUnitIds.every(
    (id) => !excludedUnitIds.includes(id)
  );

  return (
    <Stack sx={{ gap: 2, px: 2 }}>
      <Stack
        sx={{
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexDirection: 'row',
          gap: 2
        }}
      >
        <Typography fontSize={{ xs: 14, md: 16 }} fontWeight={500}>
          {courseName}
        </Typography>
        <Stack sx={{ minWidth: 120, alignItems: 'flex-end' }}>
          <Button
            variant="text"
            sx={{ p: 0 }}
            onClick={() => onToggleSelection(courseUnitIds, allUnitsSelected)}
          >
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                fontWeight: 600,
                textDecoration: 'underline',
                textTransform:'none'
              }}
            >
              {allUnitsSelected ? 'Deselect all' : 'Select all'}
            </Typography>
          </Button>
        </Stack>
      </Stack>
      <Stack sx={{ gap: 1, px: { xs: 0, md: 1 }, alignItems: 'flex-start' }}>
        {courseUnits.map(({ unit }) => (
          <Stack
            key={unit.id}
            sx={{ flexDirection: 'row', gap: '12px', alignItems: 'flex-start' }}
          >
            <Checkbox
              sx={{ padding: 0 }}
              checked={!excludedUnitIds.includes(unit.id)}
              onChange={(_, checked) => onToggleSelection([unit.id], !checked)}
            />
            <Stack
              sx={{
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 0, md: '12px' }
              }}
            >
              <Typography
                sx={{ fontSize: { xs: 14, md: 16 }, color: '#00000099' }}
              >
                {unit.code}
              </Typography>
              <Typography
                sx={{ fontSize: { xs: 14, md: 16 }, color: '#000000DE' }}
              >
                {unit.title}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default CourseUnits;
